import { Cell } from '@table-library/react-table-library/table';

/**
 * The two tables this report defines for itself: the applied filter rules, and what the retrieval
 * cursors cover. Every other table on the page is one of the shared GSC tool column sets.
 */

export const RULE_COLUMNS = (t) => [
    {
        label: t('tools.pages_queries_changes.rules.name'),
        key: 'name',
        data: 'name',
        sortType: 'string',
        cellSize: 'minmax(140px, 1fr)',
        Component: Cell,
        renderCell: ({ data }) => data || '—',
    },
    {
        label: t('tools.pages_queries_changes.rules.dimension'),
        key: 'dimension',
        data: 'dimension',
        sortType: 'string',
        cellSize: 'minmax(110px, 0.8fr)',
        Component: Cell,
    },
    {
        label: t('tools.pages_queries_changes.rules.operator'),
        key: 'operator',
        data: 'operator',
        sortType: 'string',
        cellSize: 'minmax(140px, 1fr)',
        Component: Cell,
    },
    {
        label: t('tools.pages_queries_changes.rules.expression'),
        key: 'expression',
        data: 'expression',
        sortType: 'string',
        cellSize: 'minmax(260px, 2.4fr)',
        Component: Cell,
        // The expression is shown verbatim, as a pattern rather than as prose: a regex that is
        // re-wrapped or prettified is no longer the regex that was sent.
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <code className="gsc-tool-expression">{data}</code>,
    },
];

export const RETRIEVAL_COLUMNS = (t) => [
    {
        label: t('tools.pages_queries_changes.retrieval.measure'),
        key: 'measure',
        data: 'measure',
        sortType: 'string',
        cellSize: 'minmax(220px, 2fr)',
        Component: Cell,
    },
    {
        label: t('tools.gsc.coverage.current'),
        key: 'current',
        data: 'current',
        sortType: 'string',
        cellSize: 'minmax(180px, 1.5fr)',
        Component: Cell,
        renderCell: ({ data }) => data ?? '—',
    },
    {
        label: t('tools.gsc.coverage.baseline'),
        key: 'baseline',
        data: 'baseline',
        sortType: 'string',
        cellSize: 'minmax(180px, 1.5fr)',
        Component: Cell,
        renderCell: ({ data }) => data ?? '—',
    },
];
